module.exports = __webpack_public_path__ + "img/Ukraine.6e8fece8.svg";